/* eslint-disable */
import { withStyles } from '@material-ui/core';
import React from 'react';
import ReactCalendar from 'react-calendar';
import { compose } from 'redux';
import startOfToday from '../../Support/DateTime/StartOfToday/DateTimeStartOfToday.support';
import themeCreateInjectableStyles from '../../Support/Theme/CreateInjectableStyles/ThemeCreateInjectableStyles.support';
import CalendarPropTypes from './Calendar.component.props';
import calendarStyles from './Calendar.component.styles';

/**
 * CalendarComponent
 * @export
 * @class CalendarComponent
 * @extends {React.Component<CalendarComponentComposedProps, CalendarComponentState>}
 */
export class CalendarComponent extends React.Component {
  /**
   * The `props` to seed when any specific prop receives an `undefined` value. NOT a `null` value
   * @static
   * @type {Partial<CalendarComponentProps>}
   * @memberof CalendarComponent
   */
  static defaultProps = {
    maxDate: null,
    maxDaysFromMinDate: null,
    minDate: startOfToday(),
  };

  /**
   * The name of the Component to display when debugging
   * @static
   * @type {`Calendar`}
   * @memberof CalendarComponent
   */
  static displayName = `Calendar`;

  /**
   * The values to use to apply runtime typechecking on the props
   * @static
   * @type {object}
   * @memberof CalendarComponent
   */
  static propTypes = CalendarPropTypes;

  /**
   * Data specific to the `<CalendarComponent />` instance
   * @type {CalendarComponentState}
   * @memberof CalendarComponent
   */
  state = {};

  /**
   * Render the component
   * @returns {React.Component} The rendered `<CalendarComponent />`
   * @memberof CalendarComponent
   */
  render() {
    const { classes, minDate, maxDate, maxDaysFromMinDate, ...calendarProps } = this.props;
    return <ReactCalendar className={classes.root} maxDate={maxDate} minDate={minDate} next2Label={null} prev2Label={null} {...calendarProps} />;
  }
}

/** @type {React.ComponentClass<CalendarComponentProps>} */
const Calendar = compose(withStyles(themeCreateInjectableStyles(calendarStyles), { withTheme: true }))(CalendarComponent);

export default Calendar;
